var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3 mt-md-4"},[_c('h5',{staticClass:"text-dark font-weight-bold mb-3"},[_vm._v(_vm._s(_vm.titulo))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }